module.exports = __webpack_public_path__ + "static/media/middle-node.d3feb726.svg";